export default [
  {
    name: 'tetherusd_tezos',
    tokenId: '0',
    displayName: 'Tether USD',
    decimals: 6,
    ticker: 'USDTTEZOS',
    displayTicker: 'USDT',
    contract: 'KT1XnTn74bUtxHfDtBmm2bGZAQfhPbvKWR8o',
    tokenType: 'FA2',
    info: {
      description:
        'Tether is a multi-chain stablecoin. Each USDT token is designed to be backed by a U.S. Dollar held in banking reserves.',
      reddit: 'https://www.reddit.com/r/Tether',
      telegram: 'https://t.me/OfficialTether',
      twitter: 'https://twitter.com/Tether_to',
      website: 'https://tether.to',
    },
    primaryColor: '#53AE94',
    gradientColors: ['#53AE94', '#2E9175'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
]
